<script setup>
import { isEmpty } from 'lodash'
import { onMounted } from 'vue'
import { useI18n } from 'vue-i18n'

import { SCHEDULE_SELECT_ATTRS } from '@/utils/check-ins/schedule-ui-helpers'

import FormCaption from '@/components/check-ins/FormCaption'
import { NOTIFICATION_WEBHOOK_FIELD_TEST_ID } from '@/components/check-ins/jest-helpers'
import AppSelect from '@/components/ui/AppSelect/AppSelect'

defineOptions({
  name: 'ScheduleWebhooksSelect',
  inheritAttrs: false
})

const model = defineModel({
  type: Array,
  required: true,
  set: value => value
})

const props = defineProps({
  loading: {
    type: Boolean
  },

  options: {
    type: Array,
    default: () => []
  }
})

const { t } = useI18n()

const emit = defineEmits({
  'request-options': null
})

onMounted(() => {
  if (isEmpty(props.options)) {
    emit('request-options')
  }
})
</script>

<template>
  <FormCaption
    :data-auto-testid="$attrs['data-auto-testid'] || null"
    :data-testid="$attrs['data-testid'] || null"
    :subtitle="t('schedule.notifications_webhooks.label')"
  >
    <div class="sws-SelectWrapper">
      <AppSelect
        v-model="model"
        :data-auto-testid="NOTIFICATION_WEBHOOK_FIELD_TEST_ID"
        :data-testid="NOTIFICATION_WEBHOOK_FIELD_TEST_ID"
        :dropdown-search="false"
        :loading="loading"
        :options="options"
        append-icon-name="plus-next"
        append-to="parent"
        boundary="scrollParent"
        dropdown-width="100%"
        hide-selected-items-in-dropdown
        multi
        show-all-selected
        v-bind="{
          ...SCHEDULE_SELECT_ATTRS,
          dropdownMinWidth: 220
        }"
      >
        <template #button-content="{ options: selectedOptions }">
          <div v-if="isEmpty(selectedOptions)" class="sws-EmptyOption">
            {{
              t('common.select_entity', {
                entity: t('notifications.channels').toLowerCase()
              })
            }}
          </div>
        </template>
      </AppSelect>
    </div>
  </FormCaption>
</template>

<style lang="scss" scoped>
.sws-SelectWrapper {
  position: relative;
  width: 100%;
  max-width: 100%;
  --select-skeleton-top: 0;
  --select-skeleton-left: 0;

  :deep(.as-AppDroplistButton_Content) {
    padding: 6px 0 6px 6px;
  }
}

.sws-EmptyOption {
  color: var(--gray-blue-500);
  font-size: $fs-12;
  padding-left: 5px;
}
</style>
